import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-linksFR',
  templateUrl: '../../../../assets/html/fabrikanten_linksFR.html',
  styleUrls: ['./linksFR.component.css']
})
export class LinksFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
